// src/validation/contactRequest.schema.js
import * as yup from "yup";
import { parsePhoneNumberFromString } from "libphonenumber-js";

function isValidE164(value) {
  if (!value) return false;
  const phone = parsePhoneNumberFromString(value);
  return phone && phone.isValid();
}

export const contactRequestSchema = yup.object({
  fullName: yup
    .string()
    .required("Full name is required")
    .min(3, "At least 3 characters")
    .max(50, "Maximum 50 characters"),

  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),

  phone: yup
    .string()
    .required("Phone number is required")
    .matches(
      // 1) (?=(?:.*\d){10,}) → assert there are at least 10 digits
      // 2) [+\d\s\-()]+       → only allow +, digits, spaces, hyphens, parentheses
      /^(?=(?:.*\d){10,})[+\d\s\-()]+$/,
      "Enter a valid phone number with at least 10 digits"
    ),

  paymentOption: yup
    .string()
    .oneOf(["full", "installments"], "Select a valid payment option")
    // when `requiresPayment` (from context) is true, then it’s required:
    .when("$requiresPayment", {
      is: true,
      then: (schema) => schema.required("Payment option is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  // baseDeposit: yup.number().when("paymentOption", {
  //   is: "installments",
  //   then: (schema) => schema.required("Base Deposit is required"),
  // }),
  // creditScore: yup.string().when("paymentOption", {
  //   is: "installments",
  //   then: (schema) => schema.required("Credit Score is required"),
  // }),

  message: yup
    .string()
    .max(500, "Max 500 characters")
    .required("Description is required"),
});
